module.exports = __webpack_public_path__ + "img/box-questionmark.c48bbdd3.svg";